import React, { useState, useEffect} from 'react';
import { translate } from 'react-i18next';
import _ from 'lodash';
import { EVENT } from '../../../events/listEvents';
import Utils from "../../../common/CommonUtil"
import MessageAction from '../../../actions/MessageAction';
import { useDispatch, useSelector } from 'react-redux';
import withRouter from '../../../decorator/withRouter';
import { AccountsSlice } from '../../../slices/AccountsSlice';

const LoginMessageComponent = (props) => {
  const { actions } = AccountsSlice;
  const dispatch = useDispatch();
  const [subject, setSubject] = useState();
  const [message, setMessage] = useState();
  const { loginId, hasVipWelcomeMessage } = useSelector(state => state.AccountsSlice.user);
  const [showLoginMessage, setShowLoginMessage] = useState()
  const isLoginSuccessFirstTime = hasVipWelcomeMessage === false ? localStorage.removeItem('isLoginSuccessFirstTime') : localStorage.getItem('isLoginSuccessFirstTime');
  useEffect(() => {
    window.listenEvent(EVENT.FIND_OUT_MORE, onCloseLoginMessage);
    if (isLoginSuccessFirstTime === 'true' && hasVipWelcomeMessage) {
      getLoginMessage();
    }

    return () => {
      window.stopListenEvent(EVENT.FIND_OUT_MORE);
    }
  }, [hasVipWelcomeMessage]);

  useEffect(() => {
    if(hasVipWelcomeMessage && _.isBoolean(showLoginMessage) && !showLoginMessage) {
      MessageAction.readLoginMessage().then(res => {
        dispatch(actions.updateUser({ 'hasVipWelcomMessage': res }))
      });
    }
  }, [showLoginMessage])

  function getLoginMessage() {
    MessageAction.getLoginMessage().then(res => {
      if (res) {
        setSubject(res.subject);
        setMessage(res.text);
        setShowLoginMessage(true)
      }
    });
  }

  function onCloseLoginMessage() {
    setShowLoginMessage(false);
    localStorage.removeItem('isLoginSuccessFirstTime');
  }

  function messageContent() {
    const text = message.replace('{loginId}', loginId).replace('{prestigeClubLink}', prestigeClubLink());
    return (
      <React.Fragment>
        <div dangerouslySetInnerHTML={{ __html: props.t(text,{ 0: `window.fireEvent('${EVENT.FIND_OUT_MORE}')` })}}></div>
      </React.Fragment>
    );
  }

  function prestigeClubLink() {
    return `<a href=/${Utils.getCurrentLang()}/prestige-club onClick={{0}}></a>`;
  }

  return (
    showLoginMessage && (
    <div className="LoginMessageComponent">
      <div id="login-message">
        <div className="message-header">
          <span className="prestige-header">
            <i className="prestige-logo"></i>
            <span className="header-title">{!_.isEmpty(subject) ? subject : props.t('Prestige Club')}</span>
          </span>
          <i className="fal fa-times close-icon" onClick={onCloseLoginMessage}></i>
        </div>
        <div className="message-content">
          {messageContent()}
        </div>
        <div className="message-footer">
        </div>
      </div>
    </div>
    )
  )
}

export default withRouter(translate()(React.memo(LoginMessageComponent)));



// WEBPACK FOOTER //
// ./src/app/components/CompactView/LoginMessageComponent/index.js